var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 133 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m73.705 29.353h-19.065c-3.1558 0-5.714 2.4212-5.714 5.4078v52.858c0 2.9867 2.5582 5.4078 5.714 5.4078h19.065c3.1558 0 5.714-2.4211 5.714-5.4078v-52.858c0-2.9866-2.5582-5.4078-5.714-5.4078z",
    fill: "#00C65E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m79.375 34.761c0-2.9866-2.5583-5.4078-5.7141-5.4078-0.8143 11.227-2.0872 23.645-5.944 39.092-3.8568 15.447-10.793 24.583-7.6376 24.583h13.582c3.1558 0 5.7141-2.4211 5.7141-5.4078v-52.858z",
    fill: "#08A636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m79.417 50.169h-30.493v1.4014h30.493v-1.4014z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m52.35 56.945v6.0679h2.0269v-6.0679h-2.0269z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m52.342 38.242v6.0679h2.0268v-6.0679h-2.0268z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m89.676 97.665s-2.185 1.957-10.904 1.957-10.897-1.957-10.897-1.957l1.3441-17.045c0.3928-4.9838 4.2803-9.0413 9.5601-9.0413 5.2729 0 9.2017 4.1031 9.5532 9.0413l1.3441 17.045z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m93.788 84.383c0 3.2095-5.0041 7.1431-5.0041 7.1431-2.9638 0-5.7209-4.7294-5.7209-7.1431 0-2.4136 1.93-4.4097 5.1833-4.5663 3.1155-0.1892 5.5417 1.2982 5.5417 4.5663z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m78.782 72.72c0.8643 0 1.565-0.6631 1.565-1.4811s-0.7007-1.4811-1.565-1.4811-1.5649 0.6631-1.5649 1.4811 0.7006 1.4811 1.5649 1.4811z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m74.631 93.882-4.5147 1.7678-7.6439-14.938 3.8805 0.0131 8.2781 13.158z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m92.05 98.69s-2.1918 1.957-10.904 1.957c-8.7123 0-10.897-1.957-10.897-1.957l1.3786-17.046c0.386-4.9903 4.2734-9.0478 9.5532-9.0478s9.2086 4.1031 9.5601 9.0478l1.3096 17.046z",
    fill: "#FFB762"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m91.424 93.315h-0.2964c-3.5704 0-6.5205-5.2187-6.5205-7.9063 0-2.9616 2.44-5.1599 5.9415-5.3491 0.8556-0.0848 1.7204-0.0035 2.5417 0.2387 0.8213 0.2423 1.5817 0.6405 2.2349 1.1703 0.5384 0.5127 0.9594 1.1248 1.2369 1.7982s0.4054 1.3936 0.376 2.1158c0 3.5226-5.073 7.5606-5.2936 7.7302l-0.2205 0.2022zm-0.3654-11.742h-0.3859c-2.6468 0.1501-4.4251 1.683-4.4251 3.8292s2.4055 6.0536 4.6456 6.3602c1.4406-1.1937 4.4665-4.1618 4.4665-6.3602 0.0345-0.5191-0.0464-1.0393-0.2376-1.527-0.1911-0.4876-0.4882-0.9319-0.8721-1.3041-0.8909-0.7049-2.0322-1.0618-3.1914-0.9981z",
    fill: "#FFB762"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m81.126 73.745c0.8643 0 1.5649-0.6631 1.5649-1.4811 0-0.8179-0.7006-1.481-1.5649-1.481s-1.565 0.6631-1.565 1.481c0 0.818 0.7007 1.4811 1.565 1.4811z",
    fill: "#FFB762"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m76.976 94.906-4.5147 1.7679-7.6371-14.945 3.8806 0.0196 8.2712 13.158z",
    fill: "#FFB762"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m71.902 79.782 18.531 0.0211c-0.0898-0.5158-0.4766-1.401-0.4766-1.401l-17.605 5e-4c-0.1172 0.4364-0.377 0.9395-0.4493 1.3794z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m82.484 75.956h-3.1092l0.5377-0.6003h2.0338l0.5377 0.6003z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m88.557 93.197-1.0546 1.6177-0.4067-10.457 1.1304 0.4827 0.3309 8.3564z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m47.427 89.882 6.9495-1.6305-7.0402-1.655-1.6839-6.4484-1.6904 6.4484-7.0402 1.655 6.9495 1.6305 1.7811 6.7917 1.7746-6.7917z",
    fill: "#FD9558"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m40.25 72.19 4.0869-0.9623-4.1451-0.9746-0.991-3.7943-0.9974 3.7943-4.1451 0.9746 4.0933 0.9623 1.0492 3.9966 1.0492-3.9966z",
    fill: "#FD9558"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "effect1_dropShadow_5137_20157"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_20157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_20157",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e618369e72e58ac62efee52d3a101627.svg";
export { ForwardRef as ReactComponent };